import { Box, Flex } from '@chakra-ui/react'
import React from 'react'

export default function QtyBar({qty,serviceable,unServiceable}) {
  return (
    <Flex color="white" justifyContent={"space-between"}>
        <Box p="5px" rounded="5px" textAlign={"center"} width={"100px"} bg="green">{qty}</Box>
        <Box p="5px" rounded="5px" textAlign={"center"} width={"80px"} bg="purple">{serviceable}</Box>
        <Box p="5px" rounded="5px" textAlign={"center"} width={"80px"} bg="blue">{unServiceable}</Box>
    </Flex>
  )
}
